<app-modal-box [maxWidth]="800" [allowOverflow]="true" [gapValue]="'0px'">
  <ng-container modal-header>
    @if(supportService.currentTicket.status !== 'Closed') {
    <button class="button small red" (click)="closeTicket()">Close Ticket</button>
    }
    <div class="ticket-modal-title">{{ supportService.currentTicket.title }}</div>
  </ng-container>
  <div class="ticket-chat-content">
    <div class="ticket-info">
      <div class="information">
        Created At <span class="highlight">{{ supportService.currentTicket.opened | date : 'medium' }}</span> | Category:
        <span class="highlight">{{ supportService.getCategoryById(supportService.currentTicket.category).name }}</span> | Associated:
        <span class="highlight">{{ supportService.currentTicket.associated }}</span>
      </div>
    </div>
    <div class="responses">
      @for(message of supportService.currentTicketMessages; track $index){
      <div class="response" [class]="getRoleClass(message.role)">
        <img [ngSrc]="message.avatar" class="avatar" width="32" height="32" [toggleUserAction]="message.steamid !== '-1' ? message : null" />
        <div class="right">
          <div class="top">
            <div class="name" [toggleUserAction]="message.steamid !== '-1' ? message : null">{{ message.name | name }}</div>
            @if(message.role){
            <div class="tag user-level badge badge_rounded badge_font-l">{{ getRoleTag(message.role) }}</div>
            }
            <span class="message-date">{{ message.time | date : 'dd/MM/yyyy, HH:mm:ss' }}</span>
          </div>
          <div class="message" [innerHTML]="message.response | chatEmote : 1000"></div>
        </div>
      </div>
      }
    </div>
    @if(supportService.currentTicket.status === 'Closed'){
    <div class="ticket-solved__wrapper">
      <div class="icon-container">
        <app-icon [width]="16" icon="check" />
      </div>
      <div class="text-container">
        <p class="solved-heading">This ticket is marked as Solved</p>
        @if(isTicketClosedByCurrentUser()) {
        <p class="solved-description">You closed this ticket.</p>
        } @else {
        <p class="solved-description">Staff member flagged this ticket and closed the responses.</p>
        }
      </div>
    </div>
    } @else {
    <div class="input-group">
      <input type="text" placeholder="Enter message..." [(ngModel)]="message" (keyup.enter)="sendMessage()" />
      <div class="right">
        <button class="send-button" (click)="sendMessage()">
          <app-icon icon="send" />
        </button>
      </div>
    </div>
    }
  </div>
</app-modal-box>
